import { Modal, } from 'antd'
import { CloseOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';

export const UploadInstructions = ({ open, setOpen, }) => {

    return (
        <Modal
            open={open}
            onCancel={() => setOpen(false)}
            footer={[]}
            closeIcon={false}
        >
            <div style={{ padding: '10px' }}>
                <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Title level={5}>Data Upload Instructions</Title>
                    <CloseOutlined className='custom_close_icon' onClick={() => setOpen(false)} />
                    {/* <Button  type='text' icon={<CloseOutlined style={{color:'gray'}} />} onClick={() => setOpen(false)} /> */}

                </div>

                <div>
                    <div className='instructions_modal_list'>
                        <div><span className='instruction_dot'></span></div>
                        <p>
                            <span style={{ color: "#202020", fontSize: '13px' }}>The following columns are required -</span>
                            <span style={{ color: "#328DF8", marginLeft: '5px', fontSize: '13px', }}>specification concat, card no, defect count, compliance count, raw finding rate, total effort hours, task description, fec, custom repeat, custom initial, mrbr repeat, mrbr initial, spect type, task type, and regulatory item</span>
                        </p>
                    </div>
                    <div className='instructions_modal_list'>
                        <div><span className='instruction_dot'></span></div>
                        <p>
                            <span style={{ color: "#202020", fontSize: '13px' }}>The order of the columns does not matter. Also, if the data has any additional columns, they will be removed</span>
                        </p>
                    </div>
                    <div className='instructions_modal_list'>
                        <div><span className='instruction_dot'></span></div>
                        <p>
                            <span style={{ color: "#202020", fontSize: '13px' }}>Only the following columns are expected to have null values: </span>
                            <span style={{ color: "#328DF8", marginLeft: '5px', fontSize: '13px', }}>raw rinding rate, fec, custom initial, custom repeat, mrbr initial, mrbr repeat, task type</span>
                        </p>
                    </div>
                    <div className='instructions_modal_list'>
                        <div><span className='instruction_dot'></span></div>
                        <p>
                            <span style={{ color: "#202020", fontSize: '13px' }}>The task type column can have only the following values other than null: </span>
                            <span style={{ color: "#328DF8", marginLeft: '5px', fontSize: '13px', }}>OPC, FNC, VCK, VISUAL CHECK, GVI, CHECK/INSP, DET, DVI, INSP, SDI, SPT, ZONAL (GV), CLN, CLEAN, CLEAN/INSP, SVC, SERVICE, RST, DIS, DISCARD, LUB, SAMP, DISINFECT, INST, ROUTE, RESTORE, REPLACE</span>
                        </p>
                    </div>
                    <div className='instructions_modal_list'>
                        <div><span className='instruction_dot'></span></div>
                        <p>
                            <span style={{ color: "#202020", fontSize: '13px' }}>Defect count and compliance count should only have whole numbers</span>
                        </p>
                    </div>
                    <div className='instructions_modal_list'>
                        <div><span className='instruction_dot'></span></div>
                        <p>
                            <span style={{ color: "#202020", fontSize: '13px' }}>Raw Finding Rate, and Total Effort Hours can have decimals</span>
                        </p>
                    </div>
                </div>

            </div>
        </Modal>
    )
}
